import { gql } from '@apollo/client';

export const GET_USER_CLASSES = gql`
  query getUserClasse($id: ID!) {
    usersPermissionsUser(id: $id) {
      data {
        attributes {
          classes {
            data {
              id
              attributes {
                name
                operationid
                filliere {
                  data {
                    attributes {
                      name
                    }
                  }
                }
                lycee {
                  data {
                    attributes {
                      name
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
